export enum API_RESULT {
  IDLE = "idle",
  LOADING = "loading",
  SUCCEEDED = "succeeded",
  FAILED = "failed",
}
export enum STATE {
  UPDATE_CONTACT_DETAILS = 0,
  ACTIVATE_CREDIT_CARD = 1,
  TAX_REFAUND = 2,
}
export enum POPUP_TYPE {
  WARNING = "warning",
  LEADS_TRANSFERRING_POPUP = "leadTransferring",
  DIGITAL_AGENT = "digitalAgent",
  FAQ = "faq",
}
export enum URL_SOURCE_TYPE {
  ENSURE = "ensure",
  SMS = "sms",
  MARKETING = "marketing",
  DIGITAL = "digital",
  DIGITAL_AGENT = "digital-agent",
  PFS_REP = "pfs-rep",
  CAMPAIGN = "campaign",
  REP_MANUAL = "pfs-rep-manual",
  TAX_REFAUND_IFRAME = "tax-refund-iframe",
  SMS_SHARE = "sms-share",
  SALES_REP = "sales-rep",
  APP = "app",
}
export enum ROUTES {
  HOME = "/",
  SUCCESS = "/success",
  FAILURE = "/failure",
  TAX_REFAUND_IFRAME = "tax-refund-iframe",

  /** Login screens */
  LOGIN = "login",
  LOGIN_DETAILS = "details",
  LOGIN_OTP = "otp",
  LOGIN_CHOOSE_POLICY = "choose-policy",
  TESTING_SCREEN = "testing",
  /** More screens */
  UPDATE_CONTACT_DETAILS = "update-contact-details",
  ACTIVATE_CREDIT_CARD = "activate-credit-card",
  TAX_REFAUND = "tax-refund",
  ERROR_SCREEN = "error",
  LEADS_TRANSFERRING_POPUP = "leads-transferring-popup",
  SUMMARY_SCREEN = "summary",
  AGENT = "agent",
  MUST_LIST_SCREEN = "must-list",
  PC_PLUS_SCREEN = "pc-pay",
}
export enum INPUT_LENGTH {
  ID = 9,
  PHONE = 10,
  OTP = 6,
  ZIP = 7,
}
export enum LOGIN_STEP {
  LOGIN = "/login/details",
  OTP = "/login/otp",
  CHOOSE_POLICY = "/login/choose-policy",
}

export enum CHANNELS {
  ENSURE = 1,
  DIGITAL = 2,
  DIGITAL_AGENT = 3,
  SMS = 4,
  PFS_REP = 5,
  MARKETING = 6,
  CAMPAIGN = 7,
  REP_MANUAL = 8,
  SMS_SHARE = 9,
  APP = 10,
}
export enum AUTOCOMPLETE {
  CITY = "city",
  ADDRESS = "address",
  NONE = "none",
  ZIP = "zip",
  HOUSE_NUMBER = "house-number",
  NATIONALITY = "nationality",
}
export enum DIGITAL_AGENT_BUTTONS {
  CONTACT_CUSTOMER = "contact-customer",
  SEND_LINK = "share-link",
  NOT_RELEVANT = "not-relevant",
  BACK_TO_BENEFITS = "back-to-benefits",
  OK_BUTTON_CLICKED_ON_CREDIT_CARD_SCREEN = "ok-button-clicked-on-credit-card-screen",
}
export enum SMARKLOOK_EVENT {
  PAGE_VISIT = "page_visit",
  BUTTON_CLICK = "button_click",
  FORM_SUBMIT = "form_submit",
}
export enum COLLECT_CARD_INSTRUCTION {
  NONE = 0,
  COLLECT = 1,
  REPLACE = 2,
  USE_EXISTING = 3,
}
export enum TEXT_TAGS {
  H1 = "h1",
  H2 = "h2",
  H3 = "h3",
  H4 = "h4",
  H5 = "h5",
  H6 = "h6",
  SPAN = "span",
  P = "p",
}
export enum CHECKBOX_TYPE {
  ROUNDED = "rounded",
  SQUARE = "square",
}
export enum INPUT_TYPE {
  NUMBER = "number",
  TEL = "tel",
  TEXT = "text",
  NUMERIC = "numeric",
  EMAIL = "email",
}
export enum INPUT_SPECIAL_TYPE {
  DROPDOWN = "dropdown",
  DATE = "date",
  TEXT = "text",
  RADIO = "radio",
}

export enum Gender {
  MALE = 'male',
  FEMALE = 'female',
  COLLECTIVE = 'collective'
}

export enum HebrowNouns {
  POLICY = "פוליסה",
  PASSENGER = "נוסע",
  DATE = "תאריך",
  OPTION = "אפשרות",
  NUMBER = "מספר",
  BUTTON = "כפתור",
}

export const HebrewNounsGenderMap: Record<HebrowNouns, Gender> = {
  [HebrowNouns.POLICY]: Gender.FEMALE,
  [HebrowNouns.PASSENGER]: Gender.MALE,
  [HebrowNouns.DATE]: Gender.MALE,
  [HebrowNouns.OPTION]: Gender.FEMALE,
  [HebrowNouns.NUMBER]: Gender.MALE,
  [HebrowNouns.BUTTON]: Gender.FEMALE,
};

export enum IDS {
  LOGIN_PERSONAL_ID_LABEL = "login-personal-id-label",
  LOGIN_PHONE_LABEL = "login-phone-label",
  LOGIN_PHONE_ERROR_MESSAGE = "error-message-login-phone",
  LOGIN_PERSONAL_ID_ERROR_MESSAGE = "error-message-login-personal-id",
  TAX_REFAUND_PASSPORT_NUMBER_LABEL = "tax-refaund-passport-number-label",
  TAX_REFAUND_PASSPORT_NUMBER_ERROR_MESSAGE = "error-message-tax-refaund-passport-number",
  TAX_REFAUND_EXPIRATION_DATE_LABEL = "tax-refaund-expiration-date-label",
  TAX_REFAUND_EXPIRATION_DATE_ERROR_MESSAGE = "error-message-tax-refaund-expiration-date",
  TAX_REFAUND_STATE_OF_ISSUE_LABEL = "tax-refaund-state-of-issue-label",
  TAX_REFAUND_STATE_OF_ISSUE_ERROR_MESSAGE = "error-message-tax-refaund-state-of-issue",
  TAX_REFAUND_EN_LAST_NAME_LABEL = "tax-refaund-en-last-name-label",
  TAX_REFAUND_EN_LAST_NAME_ERROR_MESSAGE = "error-message-tax-refaund-en-last-name",
  TAX_REFAUND_EN_FIRST_NAME_LABEL = "tax-refaund-en-first-name-label",
  TAX_REFAUND_EN_FIRST_NAME_ERROR_MESSAGE = "error-message-tax-refaund-en-first-name",
  TAX_REFAUND_NATION_LABEL = "tax-refaund-nation-label",
  TAX_REFAUND_NATION_ERROR_MESSAGE = "error-message-tax-refaund-nation",
  CONTACT_DETAILS_APARTMENT_ERROR_MESSAGE = "error-message-contact-details-apartment",
  CONTACT_DETAILS_ZIP_ERROR_MESSAGE = "error-message-contact-details-zip",
}

export enum BusinessUnit {
  PCIL = "PCIL",
  PCAU = "PCAU",
  IPMIL = "IPMIL",
  IPMDE = "IPMDE",
}
export enum UserPlatform {
  WEB_DESKTOP = "web_desktop",
  WEB_MOBILE = "web_mobile",
  WEB_TABLET = "web_tablet",
}
export enum GetCCInfoError {
  POLICY_NOT_FOUND = "Policy not found",
}
export enum RecordingState {
  PAUSED = 0,
  ACTIVE = 1,
}
// GeneralError = 'GeneralError', //2/4/5/6/12/13
//   TravelerInDebt = 'TravelerInDebt', // 3
//   PolicyExpired = 'PolicyExpired', // 7/8
//   AnnualPolicy = 'AnnualPolicy', // 11
//   IsTravelerMinor = 'IsTravelerMinor', // 10
//   AlreadyRegistered = 'AlreadyRegistered', // 14
//   PhoneMissing = 'PhoneMissing', // 9
//   TimeOut = 'TimeOut' // 15

export enum ErrorResponseCode {
  TIMEOUT = 15,
  GENERAL_ERROR = 12,
}
export enum PolictSupplier {
  INOVAT = "inovat",
  GLOBAL_BLUE = "global_blue"
}